import { render, staticRenderFns } from "./TicketGrido.vue?vue&type=template&id=ba5b0d88"
import script from "./TicketGrido.vue?vue&type=script&lang=js"
export * from "./TicketGrido.vue?vue&type=script&lang=js"
import style0 from "./TicketGrido.vue?vue&type=style&index=0&id=ba5b0d88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports